// API Configuration - No backend dependency
export const API_CONFIG = {
  BASE_URL: null, // No backend URL needed
  TIMEOUT: 10000,
};

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  NAVIGATE: '/navigate',
  ENTRY: '/entry',
  UPLOAD: '/upload',
  DASHBOARD: '/dashboard',
  SITE_INFO: '/site-info',
};

// Site Types
export const SITE_TYPES = {
  ACSEPL: 'ACSEPL',
  WTC: 'WTC',
  LAP: 'LAP',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  VIEWER: 'viewer',
};

// Form Types
export const FORM_TYPES = {
  AMBIENT: 'ambient',
  BD: 'bd',
  DATABANK: 'databank',
  METER_READING: 'meter_reading',
};

// File Upload
export const FILE_UPLOAD = {
  ALLOWED_TYPES: ['csv', 'xlsx', 'xls'],
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  SITE: 'site',
  USERS: 'users',
  SITES: 'sites',
  DGR_DATA: 'dgrData',
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email',
  PASSWORD_MIN: 'Password must be at least 6 characters',
  FILE_TYPE: 'Invalid file type. Only CSV, XLSX, XLS allowed',
  FILE_SIZE: 'File size must be less than 10MB',
};

// Export image constants
export * from './images';